import { BATTLE_TYPE_MESSAGES, DURATION, METERS_VALUE } from 'helpers/i18n.jsx'
import { sortReserveBattleTypes } from 'helpers/reserves'
import { getHoursFormat } from 'helpers/datetime'
import {
    RESERVE_LEVEL,
    RESERVES_PARAMETERS_CAPTIONS,
    ADDITIONAL_INDUSTRIAL_RESOURCE,
} from './translations'

import {
    BATTLE_TYPES,
    BONUS_TYPES,
    RESERVE_PARAMETERS_TYPES,
    RESERVE_TYPES,
} from 'constants'

export const getBattleBonusesColumns = (bonus, bonusType) => {
    const battleBonusesColumns = Object.keys(bonus.battle_types)
        .sort(sortReserveBattleTypes)
        .map((battleType) => {
            return {
                title: (bonusType === BONUS_TYPES.EXTRA_CREDITS && battleType === BATTLE_TYPES.RANDOM_BATTLES) ?
                    BATTLE_TYPE_MESSAGES[BATTLE_TYPES.RANDOM_BATTLES_AND_STEEL_HUNTER] :
                    BATTLE_TYPE_MESSAGES[battleType],
                dataIndex: battleType,
            }
        })

    const columns = [
        {
            title: RESERVE_LEVEL(),
            dataIndex: 'level',
            align: 'left',
            isCalculatedWidth: true,
        },
        ...battleBonusesColumns,
    ]

    if (bonus.duration) {
        columns.push({
            title: DURATION,
            dataIndex: 'duration',
            render: (value) => getHoursFormat(value / 3600),
        })
    }

    return columns
}

const getInspirationReserveColumns = () => ([
    {
        title: RESERVE_LEVEL(),
        dataIndex: 'level',
        align: 'left',
        isCalculatedWidth: true,
    },
    {
        title: RESERVES_PARAMETERS_CAPTIONS[RESERVE_PARAMETERS_TYPES.CREW_ROLES_FACTOR],
        dataIndex: RESERVE_PARAMETERS_TYPES.CREW_ROLES_FACTOR,
        render: (value) => value.replace('+', ''),
    },
    {
        title: RESERVES_PARAMETERS_CAPTIONS[RESERVE_PARAMETERS_TYPES.COMMON_AREA_RADIUS],
        dataIndex: RESERVE_PARAMETERS_TYPES.COMMON_AREA_RADIUS,
        render: (value) => METERS_VALUE(value),
    },
    {
        title: ADDITIONAL_INDUSTRIAL_RESOURCE(),
        dataIndex: BATTLE_TYPES.BATTLE_FOR_STRONGHOLD_AND_SORTIE,
    },
])

const getArtilleryStrikeReserveColumns = () => {
    return ([
        {
            title: RESERVE_LEVEL(true),
            dataIndex: 'level',
            align: 'left',
            isCalculatedWidth: true,
        },
        {
            title: RESERVES_PARAMETERS_CAPTIONS[RESERVE_PARAMETERS_TYPES.MAX_DAMAGE],
            dataIndex: RESERVE_PARAMETERS_TYPES.MAX_DAMAGE,
            isCalculatedWidth: true,
            render: (values) => values.join(' / '),
        },
        {
            title: RESERVES_PARAMETERS_CAPTIONS[RESERVE_PARAMETERS_TYPES.AREA_RADIUS],
            dataIndex: RESERVE_PARAMETERS_TYPES.AREA_RADIUS,
            isCalculatedWidth: true,
            render: (value) => METERS_VALUE(value),
        },
        {
            title: ADDITIONAL_INDUSTRIAL_RESOURCE(true),
            isCalculatedWidth: true,
            dataIndex: BATTLE_TYPES.BATTLE_FOR_STRONGHOLD_AND_SORTIE,
        },
    ])
}

export const getReserveTableColumns = (reserveType, bonus, bonusType) => {
    switch (reserveType) {
    case RESERVE_TYPES.INSPIRATION:
        return getInspirationReserveColumns()
    case RESERVE_TYPES.ARTILLERY_STRIKE:
        return getArtilleryStrikeReserveColumns()
    default:
        return getBattleBonusesColumns(bonus, bonusType)
    }
}



// WEBPACK FOOTER //
// ./components/BaseBonusInfoTable/columns.js